"use strict";

exports.__esModule = true;
var _UnitValue = require("./UnitValue");
Object.keys(_UnitValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UnitValue[key]) return;
  exports[key] = _UnitValue[key];
});
var _DurationValue = require("./DurationValue");
Object.keys(_DurationValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DurationValue[key]) return;
  exports[key] = _DurationValue[key];
});
var _PointValue = require("./PointValue");
Object.keys(_PointValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PointValue[key]) return;
  exports[key] = _PointValue[key];
});